/* eslint-disable class-methods-use-this */
export default class Header {
  constructor() {
    this.elements = {
      headerTarget: document.querySelector('.js-header'),
      preHeaderTarget: document.querySelector('.pre-header'),
      subHeaderTarget: document.querySelector('.sub-header'),
      contactAnchor: document.querySelector('#makelaar-contact'),
      contactLink: document.querySelector('.js-makelaar-contact'),
      estateAgentHeader: document.querySelector('.estate-agent-header'),
    };
    if (this.elements.headerTarget) {
      this.initHeader();
    }
  }

  initHeader() {
    const menuButtonTarget = this.elements.headerTarget.querySelector('.header__nav__menu-button');
    const subHeaderTarget = this.elements.headerTarget.querySelector('.sub-header');
    const makelaarTarget = this.elements.headerTarget.querySelector('.header__makelaar');
    const logoTarget = this.elements.headerTarget.querySelector('.header__logo-container');

    if (menuButtonTarget) {
      this.handleMenuButton(menuButtonTarget);
    }
    if (subHeaderTarget) {
      this.handleSubHeader(subHeaderTarget);
    }

    if (makelaarTarget) {
      this.handleMakelaar(logoTarget, makelaarTarget);
    }

    this.calculateHeight();
  }

  calculateHeight(subtractSubheader = true) {
    /** set dynamic height of header by making it relative, then switching it to sticky after */
    const {headerTarget, preHeaderTarget} = this.elements
    const wrapper = document.querySelector('.wrapper');

    const estateAgentBarElement = headerTarget.querySelector('.estate-agent--layout');

    let offset = 0;

    /** add the top offset of the header, which can be different on mobile */
    if (headerTarget) offset += headerTarget.getBoundingClientRect().height;

    /** subtract pre-header, as it uses position: sticky when this is set */
    if (preHeaderTarget && subtractSubheader) offset -= preHeaderTarget.getBoundingClientRect().height;

    /** use the height to set the offset of wrapper */
    if (wrapper && !headerTarget.classList.contains('with-preheader')) {
      wrapper.style.paddingTop = `${offset}px`;
      headerTarget.classList.add('initialised');
    }

    /** subtract submenu, as menu overlaps it   */
    const subHeaderTarget = this.elements.headerTarget.querySelector('.sub-header');
    if (subHeaderTarget) offset -= subHeaderTarget.getBoundingClientRect().height;

    /** subtract estate agent bar, as menu overlaps it   */
    if (estateAgentBarElement) offset -= estateAgentBarElement.getBoundingClientRect().height;

    /** also use this height to set the height of the mobile menu */
    const menu = document.querySelector('.js-mobile-menu');
    const overlay = document.querySelector('.js-mobile-menu-overlay');

    if (menu) menu.style.height = `calc(100vh - ${offset}px)`;
    if (overlay) overlay.style.height = `calc(100% - ${offset}px)`;
  }

  handleMenuButton(element) {
    element.addEventListener('click', () => {
      if (element.classList.contains('header__nav__menu-button--active')) {
        element.classList.remove('header__nav__menu-button--active');
      } else {

        /** calculate height and adjust with scroll position, as pre-header is now optional */
        if (window.scrollY > 80) {
          /** subtract 80px (height of pre-header) */
          this.calculateHeight();
        } else {
          this.calculateHeight(false);
        }

        element.classList.add('header__nav__menu-button--active');
      }
    });
  }

  handleSubHeader(element) {
    document.addEventListener('scroll', () => {
      if (element) {
        const fromTop = window.scrollY;

        if (fromTop > 320) {
          element.classList.add('sub-header--active');
        } else {
          element.classList.remove('sub-header--active');
        }

        const anchorTagsTargets = element.querySelectorAll('a');

        anchorTagsTargets.forEach((link) => {

          if (!link.hash) return;

          const section = document.querySelector(link.hash);

          if (!section) return;

          if (
            section.offsetTop <= fromTop + 150 &&
            (section.offsetTop + section.offsetHeight) > fromTop + 150
          ) {
            link.classList.add('sub-header__link--active');
          } else {
            link.classList.remove('sub-header__link--active');
          }
        });
      }
    });
  }

  handleMakelaar(logoElement, makelaarElement) {
    document.addEventListener('scroll', () => {
      const estateAgentBarElement = this.elements.headerTarget.querySelector('.estate-agent--layout');
      if (estateAgentBarElement !== null) {
        return;
      }

      if (window.pageYOffset > 160 ) {
        if (logoElement) {
          logoElement.classList.remove('header__logo-container--active');
        }
        if (makelaarElement) {
          makelaarElement.classList.add('header__makelaar--active');
        }
      } else {
        if (makelaarElement) {
          makelaarElement.classList.remove('header__makelaar--active');
        }
        if (logoElement) {
          logoElement.classList.add('header__logo-container--active');
        }
      }
    });
  }
}
